// extracted by mini-css-extract-plugin
module.exports = {"placeholderText":"_2D3KrW","button":"_2oWDzZ","selected":"_3akCV9"};